function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 15,
  stroke: "black",
  strokeWidth: 30
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask2)"
}, React.createElement("g", {
  opacity: 0.636
}, React.createElement("path", {
  d: "M36.673 55.509C49.69 55.509 56.876 35.696 56.876 22.679C56.876 9.66 39.589 5 26.571 5C13.553 5 3 15.553 3 28.57C3 41.589 23.655 55.509 36.673 55.509Z",
  stroke: "#00C1F1"
}), React.createElement("path", {
  d: "M30.78 54.667C17.762 54.667 8.05 38.221 8.05 25.204C8.05 12.186 17.762 7.525 30.78 7.525C43.798 7.525 54.35 18.078 54.35 31.096C54.35 44.114 43.798 54.667 30.78 54.667Z",
  stroke: "#00C1F1"
})));

var Svg3 = function Svg3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3.945c71f9.svg";
export { ForwardRef as ReactComponent };